import {
  getMyOpenInvoices,
  getMyClosedInvoices,
  getMyInvoices,
  getInvoiceOwners,
  getMyOpenInvoicesByEmail,
  getMyClosedInvoicesByEmail,
  getMyOpenInvoicesByOwner,
  getMyClosedInvoicesByOwner,
} from './services/reports-api';

import {
  getUserCredits,
} from './services/usercredits-api';
import {
  getRegistrationStatus,
  getOnHoldes,
  getFacilityStatus,
  getReportSites,
} from './services/site-info-api';

export const SET_MY_INVOICES = 'reports/SET_MY_INVOICES';
export const FETCH_MY_INVOICES = 'reports/FETCH_MY_INVOICES';
export const SET_MY_OPEN_INVOICES = 'reports/SET_MY_OPEN_INVOICES';
export const FETCH_MY_OPEN_INVOICES = 'reports/FETCH_MY_OPEN_INVOICES';
export const SET_MY_CLOSED_INVOICES = 'reports/SET_MY_CLOSED_INVOICES';
export const FETCH_MY_CLOSED_INVOICES = 'reports/FETCH_MY_CLOSED_INVOICES';
export const SET_MY_USERCREDITS = 'reports/SET_MY_USERCREDITS';
export const FETCH_MY_USERCREDITS = 'reports/FETCH_MY_USERCREDITS';
export const SET_SELECTED_USER = 'reports/SET_SELECTED_USER';
export const FETCH_INVOICE_OWNERS = 'reports/FETCH_INVOICE_OWNERS';
export const SET_INVOICE_OWNERS = 'reports/SET_INVOICE_OWNERS';

export const SET_REGISTRATION_STATUS = 'reports/SET_REGISTRATION_STATUS';
export const FETCH_REGISTRATION_STATUS = 'reports/FETCH_REGISTRATION_STATUS';
export const SET_FACILITY_STATUS = 'reports/SET_FACILITY_STATUS';
export const FETCH_FACILITY_STATUS = 'reports/FETCH_FACILITY_STATUS';
export const SET_ON_HOLD = 'reports/SET_ON_HOLD';
export const FETCH_ON_HOLD = 'reports/FETCH_ON_HOLD';
export const SET_REPORT_SITES = 'reports/SET_REPORT_SITES';
export const FETCH_REPORT_SITES = 'reports/FETCH_REPORT_SITES';

export const reportsStore = {
  state: {
    myInvoices: null,
    myOpenInvoices: null,
    myClosedInvoices: null,
    myUserCredits: null,
    selectedUser: null,
    invoiceOwners: null,
    registrationStatus: null,
    onHoldes: null,
    facilityStatus: null,
    reportSites: null,
  },
  mutations: {
    [SET_MY_INVOICES](state, { myInvoices }) {
      state.myInvoices = myInvoices;
    },
    [SET_MY_OPEN_INVOICES](state, { myOpenInvoices }) {
      state.myOpenInvoices = myOpenInvoices;
    },
    [SET_MY_CLOSED_INVOICES](state, { myClosedInvoices }) {
      state.myClosedInvoices = myClosedInvoices;
    },
    [SET_MY_USERCREDITS](state, { myUserCredits }) {
      state.myUserCredits = myUserCredits;
    },
    [SET_SELECTED_USER](state, { selectedUser }) {
      state.selectedUser = selectedUser;
    },
    [SET_INVOICE_OWNERS](state, { _payload }) {
      state.invoiceOwners = _payload;
    },
    [SET_REGISTRATION_STATUS](state, { _payload }) {
      state.registrationStatus = _payload;
    },
    [SET_ON_HOLD](state, { _payload }) {
      state.onHoldes = _payload;
    },
    [SET_FACILITY_STATUS](state, { _payload }) {
      state.facilityStatus = _payload;
    },
    [SET_REPORT_SITES](state, { _payload }) {
      state.reportSites = _payload;
    },
  },
  getters: {
    myInvoices: (state) => state.myInvoices,
    myOpenInvoices: (state) => state.myOpenInvoices,
    myClosedInvoices: (state) => state.myClosedInvoices,
    myUserCredits: (state) => state.myUserCredits,
    selectedUser: (state) => state.selectedUser,
    invoiceOwners: (state) => state.invoiceOwners,
    getRegistrationStatus: (state) => state.registrationStatus,
    getOnHoldes: (state) => state.onHoldes,
    getFacilityStatus: (state) => state.facilityStatus,
    getReportSites: (state) => state.reportSites,
  },
  actions: {
    [FETCH_MY_INVOICES]: async ({ commit }, payload) => {
      const { userId } = payload;
      commit(SET_MY_INVOICES, { myInvoices: null });
      const resp = await getMyInvoices(userId);
      commit(SET_MY_INVOICES, { myInvoices: resp.data });
    },
    [FETCH_MY_OPEN_INVOICES]: async ({ commit }, payload) => {
      const { userId } = payload;
      const { email } = payload;
      const { ownerId } = payload;
      const { ownerContactId } = payload;
      commit(SET_MY_OPEN_INVOICES, { myOpenInvoices: null });
      let resp = null;
      if (userId && userId !== '00000000-0000-0000-0000-000000000000') {
        resp = await getMyOpenInvoices(userId);
      } else if (ownerId > 0 && ownerContactId > 0) {
        resp = await getMyOpenInvoicesByOwner(ownerId, ownerContactId);
      } else if (email) {
        resp = await getMyOpenInvoicesByEmail(email);
      }
      commit(SET_MY_OPEN_INVOICES, { myOpenInvoices: resp.data });
    },
    [FETCH_MY_CLOSED_INVOICES]: async ({ commit }, payload) => {
      const { userId } = payload;
      const { email } = payload;
      const { ownerId } = payload;
      const { ownerContactId } = payload;
      commit(SET_MY_CLOSED_INVOICES, { myClosedInvoices: null });
      let resp = null;
      if (userId && userId !== '00000000-0000-0000-0000-000000000000') {
        resp = await getMyClosedInvoices(userId);
      } else if (ownerId > 0 && ownerContactId > 0) {
        resp = await getMyClosedInvoicesByOwner(ownerId, ownerContactId);
      } else if (email) {
        resp = await getMyClosedInvoicesByEmail(email);
      }
      commit(SET_MY_CLOSED_INVOICES, { myClosedInvoices: resp.data });
    },
    [FETCH_MY_USERCREDITS]: async ({ commit }, payload) => {
      const { userId } = payload;
      commit(SET_MY_USERCREDITS, { myUserCredits: null });
      if (userId && userId !== '00000000-0000-0000-0000-000000000000') {
        const resp = await getUserCredits(userId);
        commit(SET_MY_USERCREDITS, { myUserCredits: resp.data });
      }
    },
    [FETCH_INVOICE_OWNERS]: async ({ commit }) => {
      try {
        commit(SET_INVOICE_OWNERS, { _payload: null });
        const resp = await getInvoiceOwners();
        commit(SET_INVOICE_OWNERS, { _payload: resp.data });
        return resp;
      } catch (error) {
        console.error(`fetch_user:${error.Status}`);
        // console.log(error);
        throw error;
      }
    },

    [FETCH_REGISTRATION_STATUS]: async ({ commit }) => {
      commit(SET_REGISTRATION_STATUS, { _payload: null });
      const resp = await getRegistrationStatus();
      commit(SET_REGISTRATION_STATUS, { _payload: resp.data });
    },
    [FETCH_ON_HOLD]: async ({ commit }) => {
      commit(SET_ON_HOLD, { _payload: null });
      const resp = await getOnHoldes();
      commit(SET_ON_HOLD, { _payload: resp.data });
    },
    [FETCH_FACILITY_STATUS]: async ({ commit }) => {
      commit(SET_FACILITY_STATUS, { _payload: null });
      const resp = await getFacilityStatus();
      commit(SET_FACILITY_STATUS, { _payload: resp.data });
    },
    [FETCH_REPORT_SITES]: async ({ commit }, payload) => {
      const { jurisdiction } = payload;
      const { facilityStatusType } = payload;
      const { registrationStatusType } = payload;
      const { onholdString } = payload;
      const { registrationDesc } = payload;
      commit(SET_REPORT_SITES, { _payload: null });
      const resp = await getReportSites(jurisdiction, facilityStatusType,
        registrationStatusType, onholdString, registrationDesc);
      commit(SET_REPORT_SITES, { _payload: resp.data });
    },
  },
};
